/**
 * @file paddlehub 通用图片 demo
 * @author FengGuang(fengguang01@baidu.com)
 */

import PictureDemo from './VideoDemo';
import './style.less';

export default PictureDemo;
